/**
 * The standard order for event and conversation lists: newest first, so the
 * latest reply is found without scrolling past older entries. Timestamps are
 * compared as points in time, so "…T10:00:00Z", "…T10:00:00.000Z" and
 * "…T12:00:00+02:00" order correctly; entries with an unparseable timestamp
 * fall back to comparing the text. Equal timestamps keep their relative order
 * (the sort is stable).
 */
export function newestFirst<T extends { createdAt: string }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => {
    const left = Date.parse(a.createdAt);
    const right = Date.parse(b.createdAt);
    if (Number.isNaN(left) || Number.isNaN(right)) return b.createdAt.localeCompare(a.createdAt);
    return right - left;
  });
}
